module.exports = __webpack_public_path__ + "static/img/shl_small_baskeball_note_1.56dbe8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shl_small_baskeball_note_1.png
// module id = l9sU
// module chunks = 5